import UserService from "../../../services/UserService";

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem("user-token") || "",
    authUser: "",
    status: ""
  }),

  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    token: state => state.token,
    getAuthUser: state => state.authUser
  },

  mutations: {
    authRequest: state => {
      state.status = "loading";
    },
    authSuccess: (state, token) => {
      state.status = "success";
      state.token = token;
    },
    authError: state => {
      state.status = "error";
    },
    setAuthUser: (state, data) => {
      state.authUser = data;
    }
  },

  actions: {
    authRequest: ({ commit }, userData) => {
      return new Promise((resolve, reject) => {
        commit("authRequest");
        UserService.userLogin(userData)
          .then(res => {
            if (res.status === 200) {
              const token = res.data.token;
              localStorage.setItem("user-token", token || ""); // store the token in localstorage
              commit("authSuccess", token);
            }
            resolve(res);
          })
          .catch(err => {
            commit("authError", err);
            localStorage.removeItem("user-token"); // if the request fails, remove any possible user token if possible
            reject(err);
          });
      });
    },
    authLogout: () => {
      return new Promise(resolve => {
        localStorage.removeItem("user-token"); // clear your user's token from localstorage
        resolve();
      });
    },
    parseToken: ({ commit }, token) => {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      commit("setAuthUser", JSON.parse(jsonPayload));
    }
  }
};
